/* eslint-disable */
export default {
  DirectNumber: 'Direct',
  MainCompanyNumber: 'Principal',
  CompanyNumber: 'Entreprise',
  CompanyFaxNumber: 'Télécopieur',
  Blocked: 'Bloqué',
  AdditionalCompanyNumber: 'Entreprise',
  ForwardedCompanyNumber: 'Transféré',
  from: 'De',
} as const;

// @key: @#@"DirectNumber"@#@ @source: @#@"Direct"@#@
// @key: @#@"MainCompanyNumber"@#@ @source: @#@"Main"@#@
// @key: @#@"CompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"CompanyFaxNumber"@#@ @source: @#@"Fax"@#@
// @key: @#@"Blocked"@#@ @source: @#@"Blocked"@#@
// @key: @#@"AdditionalCompanyNumber"@#@ @source: @#@"Company"@#@
// @key: @#@"ForwardedCompanyNumber"@#@ @source: @#@"Forwarded"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
